import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Layout } from '../../configs/ui/constant';
import { TextField } from '@material-ui/core';

export const TextFieldCustom = styled(TextField)`
  width: ${(props) => (props.width ? props.width : '100%')};
  margin: ${(props) => props.margin && props.margin};
  .MuiInputBase-input {
    text-align: ${(props) => (props.textAlign ? props.textAlign : '')};
    font-family: 'DBHeavent',sans-serif;
  }
  &:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    outline: none;
    border: 1.25px solid ${Layout.primary};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    outline: none;
    border: 1.25px solid ${Layout.primary};
  },
`;

export const Input = styled(`input`)`
   width: ${(props) => (props.width ? props.width : '100%')};
   min-height: 38px;
   display: inline-block;
   position: relative;
   margin: ${(props) => props.margin && props.margin};
   //text-indent: 10px;
   padding: 0.5rem 0.5rem;
   font-family: 'DBHeavent', sans-serif;
   font-size: ${(props) => (props.fontSize ? props.fontSize : '20px')};
   text-align: ${(props) => (props.textAlign ? props.textAlign : '')};
   border-radius: 5px;
   border: ${(props) =>
      props.alert ? '1.25px solid red' : '1.25px solid #d3d2d1'};
   box-sizing: border-box;
   &:focus {
      outline: none;
      border: 1.25px solid ${Layout.primary};
   }
   &:hover {
      outline: none;
      border: 1.25px solid ${Layout.primary};
   }
   ${(props) =>
      props.disabled
         ? props.disabled &&
           css`
              background-color: #f0f2f6;
              pointer-events: none;
           `
         : css`
              color: #515d69;
           `};
`;

export const LinkTable = styled(`div`)`
   cursor: pointer;
   &:hover {
      outline: none;
      color: ${Layout.primary};
      text-decoration: underline;
   }
`;

export const AlertLabel = styled(`span`)`
   color: red;
   font-size: 0.9rem;
   margin-left: 0.5rem;
`;

export const TextArea = styled(`textarea`)`
   width: 100%;
   max-width: 100%;
   min-width: 100%;
   min-height: 38px;
   position: relative;
   padding: 0.5rem 0.5rem;
   font-family: 'DBHeavent', sans-serif;
   font-size: ${(props) => (props.fontSize ? props.fontSize : '20px')};
   text-align: ${(props) => (props.textAlign ? props.textAlign : '')};
   border-radius: 5px;
   border: ${(props) =>
      props.alert ? '1.25px solid red' : '1.25px solid #d3d2d1'};
   box-sizing: border-box;
   &:focus {
      outline: none;
      border: 1.25px solid ${Layout.primary};
   }
   &:hover {
      outline: none;
      border: 1.25px solid ${Layout.primary};
   }
   ${(props) =>
      props.disabled
         ? props.disabled &&
           css`
              background-color: #f0f2f6;
              pointer-events: none;
           `
         : css`
              color: #515d69;
           `};
`;

export const CenterDiv = styled('div')`
   width: 100%;
   display: flex;
   align-content: center;
   align-items: center;
`;
